<template>
  <b-card style="padding:40px;">
    <h5 v-if="this.$store.getters.getAccessLevel == 2">
      <b>LIST OF HOME DEALER</b>
    </h5>
    <h5 v-if="this.$store.getters.getAccessLevel == 3">
      <b>LIST OF AGENT</b>
    </h5>
    <hr />
    <div>
      <b-card v-model="tabIndex" no-body>
        <b-tabs card>
          <b-tab :title="title_tab" active>
            <br />
            <TableSubDealerIndex
              :fields="fields.fields"
              :type="`sub`"
              :filter="this.filter"
              :page="this.page"
              :email="this.email"
              :name="this.name"
              :tab="this.tab"
            />
          </b-tab>
          <b-tab title="Stockout">
            <br />
            <h6>List Of Stockout By Day</h6>
            <hr />
            <TableStockOutByDay
              :fields="fieldsS.fieldss"
              :type="`sub`"
              :filter="this.filter"
              :page="this.page"
              :date="this.date"
              :name="this.name"
              :outlet_name="this.outlet_name"
              :tab="this.tab"
            />
          </b-tab>
        </b-tabs>
      </b-card>
    </div>
  </b-card>
</template>

<script>
import TableSubDealerIndex from "@/table/user/subDealer/TableSubDealerIndex";
import TableStockOutByDay from "@/table/user/subDealer/TableStockOutByDay";

export default {
  data() {
    return {
      title_tab: "Home Dealer",

      fields: {
        fields: [
          {
            label: "No",
            key: "index",
            sortable: false
          },
          {
            label: "Name",
            key: "name",
            sortable: true
          },
          {
            label: "Role",
            key: "role",
            sortable: true
          },
          {
            label: "Action",
            key: "action",
            sortable: false
          }
        ]
      },
      fieldsS: {
        fieldss: [
          {
            label: "No",
            key: "index",
            sortable: false
          },
          {
            label: "Name",
            key: "name",
            sortable: true
          },
          {
            label: "Outlet Category",
            key: "category",
            sortable: true,
            sortDirection: "asc"
          },
          {
            label: "Date",
            key: "date",
            sortable: true
          },
          {
            label: "Action",
            key: "action",
            sortable: false
          }
        ]
      },

      tabIndex: 0,
      tab: "0",
      filter: "",
      page: "",
      name: "",
      date: "",
      outlet_name: "",
      email: ""
    };
  },
  created() {
    // this.getSubDealer();
    // this.getDownlineStockout();

    if (this.$store.getters.getAccessLevel == 3) {
      this.title_tab = "Agent";
    }

    if (this.$route.query.tab !== undefined) {
      this.tab = this.$route.query.tab;
      if (this.$route.query.filter !== undefined) {
        this.filter = this.$route.query.filter;
        this.page = this.$route.query.page;
        this.date = this.$route.query.date;
        this.name = this.$route.query.name;
        this.outlet_name = this.$route.query.outlet_name;
        this.email = this.$route.query.email;
      }

      if (this.$route.query.tab && this.$route.query.tab === "2") {
        this.tabIndex = this.tabIndex + 1;
      }
    }
  },
  methods: {
    getSubDealer() {
      this.$store.dispatch("getSubDealer").then(res => {
        let no = 0;
        res.data.data.data.forEach(element => {
          no = no + 1;
          this.items.push({
            no: no,
            name: element.name,
            role: element.access_lvl,
            id: element.user_id
          });
        });
      });
    },
    getDownlineStockout() {
      this.$store.dispatch("getDownlineStockout").then(res => {
        res.data.data.data.forEach(element => {
          let outletCat, type;
          if (element.outlet !== null) {
            outletCat = element.outlet.name;
          }

          type = element.type === 1 ? "UHT" : "Pasteurized";
          this.itemss.push({
            name: element.userdetails.name,
            date: element.date,
            id: element.stock_id,
            type: element.type,
            pro_cat: type,
            category: outletCat
          });
        });
      });
    }
  },
  components: {
    TableSubDealerIndex,
    TableStockOutByDay
  }
};
</script>
<style lang="css" scoped></style>
